/* unplugin-vue-components disabled */import { render } from "./CollectUserCert.vue?vue&type=template&id=5f29011a&scoped=true"
import script from "./CollectUserCert.vue?vue&type=script&lang=js"
export * from "./CollectUserCert.vue?vue&type=script&lang=js"

import "./CollectUserCert.vue?vue&type=style&index=0&id=5f29011a&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f29011a"]])

export default __exports__